














































import Vue from 'vue';
import AdminNav from '@/components/AdminNav.vue'
// import AdminBranchen from '@/pages/Admin/AdminBranchen.vue'
// import AdminOrte from '@/pages/Admin/AdminOrte.vue'
// import AdminUser from '@/pages/Admin/AdminUser.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default Vue.extend({
  name: 'Admin',
  components: {
    AdminNav,
    // AdminBranchen,
    // AdminOrte,
    // AdminUser,
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods: {

  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  }

});
